import React from 'react';
import QuestionnaireEvaluation from '../../components/questionnaire-evaluation';

const CompleteAction = ({
  viewer: {
    consultPath,
    advisor,
    products,
    borrower: { name, email },
    loan: { preapprovalState },
    ...viewer
  },
  actionPipe,
  ...props
}) => {
  return (
    <QuestionnaireEvaluation
      scenario={'Preapproval'}
      consultPath={consultPath}
      products={products}
      advisor={advisor}
      name={name}
      email={email}
      state={preapprovalState}
      purpose={'preapproval'}
      viewer={viewer}
      actionPipe={actionPipe}
      reviewItems={[
        'Strengths and weaknesses of your lending profile',
        'Your borrowing limits under different scenarios',
        'Your personal home financing plan'
      ]}
      steps={[
        'Submit Your Information',
        'Schedule\u00A0a Review Call',
        'Receive Your Pre-approval'
      ]}
      {...props}
    />
  );
};

export default CompleteAction;



// WEBPACK FOOTER //
// ./src/products/preapproval/dashboard.js